import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "@/services/API";
import { trailerTypes } from "@/utils/constants";

export const trendsParams = [
  {
    trailerType: trailerTypes[0].id,
    days: 7,
  },
  {
    trailerType: trailerTypes[0].id,
    days: 30,
  },
  {
    trailerType: trailerTypes[1].id,
    days: 7,
  },
  {
    trailerType: trailerTypes[1].id,
    days: 30,
  },
  {
    trailerType: trailerTypes[2].id,
    days: 7,
  },
  {
    trailerType: trailerTypes[2].id,
    days: 30,
  },
];

const initialState = {};

trendsParams.forEach((param) => {
  initialState[`${param.trailerType}_${param.days}`] = {
    data: [],
    loading: false,
    error: null,
  };
});

export const allGetTrends = trendsParams.map((param) => ({
  thunk: createAsyncThunk(`trends/get-${param.trailerType}-${param.days}`, async (_, { rejectWithValue }) => {
    return API.get(`/analytics/outbound-rpm-per-market?trailer=${param.trailerType}&interval-in-days=${param.days}`)
      .then((res) => res)
      .catch((error) => {
        console.log(`Error fetching ${param.trailerType} ${param.days}-day trends`);
        return rejectWithValue(error);
      });
  }),
  param: param,
}));

const trendsSlice = createSlice({
  name: "trends",
  initialState,
  reducers: {
    clearTrendsState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    allGetTrends.forEach((trend) => {
      builder
        .addCase(trend.thunk.pending, (state) => {
          state[`${trend.param.trailerType}_${trend.param.days}`] = {
            data: null,
            loading: true,
            error: null,
          };
        })
        .addCase(trend.thunk.fulfilled, (state, action) => {
          state[`${trend.param.trailerType}_${trend.param.days}`] = {
            data: action.payload,
            loading: false,
            error: null,
          };
        })
        .addCase(trend.thunk.rejected, (state) => {
          state[`${trend.param.trailerType}_${trend.param.days}`] = {
            data: null,
            loading: false,
            error: `Error fetching ${trend.param.trailerType} ${trend.param.days}-day trends`,
          };
        });
    });
  },
});

export const { clearTrendsState } = trendsSlice.actions;

export default trendsSlice.reducer;
